import { createContext, useContext } from 'react';
export const FieldPropsContext = /*#__PURE__*/createContext(null);
export function useFieldProps() {
  const context = useContext(FieldPropsContext);
  if (context === null) {
    throw new Error('useFieldProps must be used within a FieldPropsProvider');
  }
  return context;
}
//# sourceMappingURL=field-props-context.js.map